import React, { useState } from 'react';
import classnames from 'classnames';
import moment from 'moment';

import AveragesTable from './AveragesTable';
import CountChart from './CountChart';
import CountTable from './CountTable';
import { useEmails } from './email';
import EmailHelper from './EmailHelper';

const emailHelper = new EmailHelper();

export default function App() {
    const { emails, status, error, refetch } = useEmails();
    const [grouping, setGrouping] = useState('by date');

    let content;
    if (status === 'loading') {
        content = 'Loading emails...';
    } else if (status === 'error') {
        console.error(error);
        content = 'There was an error loading your emails';
    } else if (emails.length === 0) {
        content = 'No emails. This seems odd...';
    } else {
        console.log(`Email count is ${emails.length}`);
        const mappedEmails = emails.map(
            email => {
                const momentDate = moment(email.receivedDateTime);
                email.receivedDate = momentDate.format('YYYY-MM-DD');
                email.week = momentDate.clone().startOf('week').format('YYYY-MM-DD') + ' - ' + momentDate.clone().endOf('week').format('YYYY-MM-DD');
                email.month = momentDate.format('YYYY-MM');
                return email;
            }
        );

        const counts = emailHelper.groupBy(emails, 'receivedDate' );
        const weeklyCounts = emailHelper.groupBy(emails, 'week');
        const monthlyCounts = emailHelper.groupBy(emails, 'month');

        const total = emails.length;
        const average = (emails.length / Object.keys(counts).length).toFixed(2);
        const weeklyAverage = (emails.length / Object.keys(weeklyCounts).length).toFixed(2);
        const monthlyAverage = (emails.length / Object.keys(monthlyCounts).length).toFixed(2);

        const dateCountClick = (date) => {
            alert(date);
        }

        let chart;
        if(grouping === 'by date') {
            chart = <CountChart counts={counts} average={average} onClick={dateCountClick} label="Emails by Date"/>;
        } else if(grouping === 'by week') {
            chart = <CountChart counts={weeklyCounts} average={weeklyAverage} label="Emails by Week"/>;
        } else {
            chart = <CountChart counts={monthlyCounts} average={monthlyAverage} label="Emails by Month"/>;
        }

        content = <>
            <button className="btn btn-primary" onClick={() => refetch()}>Reload</button>
            <AveragesTable total={total}
                average={average}
                weeklyAverage={weeklyAverage}
                monthlyAverage={monthlyAverage}/>

            <div className="row justify-content-center">
                <div className="btn-group" role="group">
                    <button type="button"
                        className={classnames('btn', 'btn-primary', { active: grouping === 'by date'})}
                        onClick={() => setGrouping('by date')}>By Date</button>
                    <button type="button"
                        className={classnames('btn', 'btn-primary', { active: grouping === 'by week'})}
                        onClick={() => setGrouping('by week')}>By Week</button>
                    <button type="button"
                        className={classnames('btn', 'btn-primary', { active: grouping === 'by month'})}
                        onClick={() => setGrouping('by month')}>By Month</button>
                </div>
            </div>

            <div className="row">{chart}</div>

            <div className="row">
                <div className="col-sm">
                    <h2>By Date</h2>
                    <CountTable counts={counts}/>
                </div>
                <div className="col-sm">
                    <h2>By Week</h2>
                    <CountTable counts={weeklyCounts}/>
                </div>
                <div className="col-sm">
                    <h2>By Month</h2>
                    <CountTable counts={monthlyCounts}/>
                </div>
            </div>
        </>;
    }
    return (
        <div className='container'>
            <h1>Emails</h1>
            {content}
        </div>
    );
}
